import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchOne, updateBrick } from '../../http/brickAPI';

function UpdateBrick() {
  const { id } = useParams();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [isRegular, setIsRegular] = useState('Обычный');
  const [type, setType] = useState('1 НФ');
  const [image, setImage] = useState(null);
  const [secondImage, setSecondImage] = useState(null);
  const [thirdImage, setThirdImage] = useState(null);
  const [video, setVideo] = useState(null);

  const [currentImages, setCurrentImages] = useState({});

  useEffect(() => {
    fetchOne(id).then(data => {
      const brick = data.brick;
      setName(brick.name);
      setDescription(brick.description);
      setPrice(brick.price);
      setIsRegular(brick.is_regular || 'Обычный');
      setType(brick.type || '1 НФ');

      setCurrentImages({
        image: brick.image,
        secondImage: brick.second_image,
        thirdImage: brick.third_image,
        video: brick.video,
      });
    });
  }, [id]);

  const handleFileChange = (setter) => (e) => {
    setter(e.target.files[0]);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('description', description);
      formData.append('price', price);
      formData.append('is_regular', isRegular);
      formData.append('type', type);

      if (image) formData.append('image', image);
      if (secondImage) formData.append('second_image', secondImage);
      if (thirdImage) formData.append('third_image', thirdImage);
      if (video) formData.append('video', video);

      await updateBrick(id, formData); 
      alert('Кирпич успешно обновлен!');

    } catch (error) {
      console.error('Ошибка при обновлении:', error);
      alert('Произошла ошибка при обновлении кирпича');
    }
  };

  return (
    <div className='centered'>
      <div className='upt-container'>
        <h1>Редактировать кирпич</h1>
        <form onSubmit={handleUpdate}>
          <ul>
            <li>
              Название: <br/>
              <input
                className='update-input'
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder='Введите название'
                required
              />
            </li>
            <li>
              {currentImages.image && (
                <div>
                  <p>Текущая картинка:</p>
                  <img src={`http://localhost:7000/${currentImages.image}`} alt='Main' style={{ maxWidth: '200px',height:'100px' }} />
                </div>
              )}
              {currentImages.secondImage && (
                <div>
                  <p>Текущая вторая картинка:</p> 
                  <img src={`http://localhost:7000/${currentImages.secondImage}`} alt='Second' style={{ maxWidth: '200px',height:'100px' }} />
                </div>
              )}
              {currentImages.thirdImage && (
                <div>
                  <p>Текущая третья картинка:</p>
                  <img src={`http://localhost:7000/${currentImages.thirdImage}`} alt='Third' style={{ maxWidth: '200px',height:'100px' }} />
                </div>
              )}
              {currentImages.video && (
                <div>
                  <p>Текущее видео:</p>
                  <video controls style={{ maxWidth: '300px',height:'100px' }}>
                    <source src={`http://localhost:7000/${currentImages.video}`} type='video/mp4' />
                  </video>
                </div>
              )}
            </li>
            <li>
              <strong>Новая картинка: </strong><br/>
              <input onChange={handleFileChange(setImage)} type='file' accept='image/*' />
            </li>
            <li>
              <strong>Новая вторая картинка:</strong> <br/>
              <input onChange={handleFileChange(setSecondImage)} type='file' accept='image/*' />
            </li>
            <li>
              <strong>Новая третья картинка:</strong> <br/>
              <input onChange={handleFileChange(setThirdImage)} type='file' accept='image/*' />
            </li>
            <li>
              <strong>Новое видео: </strong><br/>
              <input onChange={handleFileChange(setVideo)} type='file' accept='video/*' />
            </li>
            <li>
              <textarea
                style={{ margin: '2% 0px' }}
                placeholder='Введите описание'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </li>
            <li>
              <select style={{ margin: '2% 0px' }} value={type} onChange={(e) => setType(e.target.value)} required>
                <option value='1 НФ'>1 НФ</option>
                <option value='1.4 НФ'>1.4 НФ</option>
              </select>
            </li>
            <li>
              <strong>Цена: </strong>
              <input
                style={{ margin: '2% 0px' }}
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder='Введите цену'
                type='number'
                required
                className='update-input'
              />
            </li>
            <li>
              <label>
                Обычный 
                <input
                  type='radio'
                  name='isRegular'
                  value='Обычный'
                  checked={isRegular === 'Обычный'}
                  onChange={() => setIsRegular('Обычный')}
                />
              </label>
            </li>
            <li>
              <label>
                Миксовый 
                <input
                  style={{ margin: '2% 0px' }}
                  type='radio'
                  name='isRegular'
                  value='Миксовый'
                  checked={isRegular === 'Миксовый'}
                  onChange={() => setIsRegular('Миксовый')}
                />
              </label>
            </li>
            <li>
              <button type='submit' className='blue-btn'>
                Обновить
              </button>
            </li>
          </ul>
        </form>
      </div>
    </div>
  );
}

export default UpdateBrick;